module.exports = __webpack_public_path__ + "static/img/img_0760.8d26f6b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portfolio/img_0760.jpg
// module id = IpRa
// module chunks = 0